import { defineLanguage } from '@render/language';

export default defineLanguage({
    _name: 'Абзац',
});